import dayjs from 'dayjs';
import Vue from 'vue';
import Router from 'vue-router';
import { checkRole, LOGIN_REDIRECT_URL } from '@/constants';
import { pinia } from '@/pinia';
import { useLeadsStatsStore } from '@/store/pinia/leadsStats';
import store from '@/store/store';

Vue.use(Router);

const router = new Router({
    base:   import.meta.env.BASE_URL,
    mode:   'history',
    routes: [

        {

            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    component: () => import('./views/Home/Index.vue'),
                    meta:      {
                        rule: 'complex',
                    },
                    name: 'statistics',
                    path: '/',
                },
                {
                    component: () => import('./views/leads/Index.vue'),
                    meta:      {
                        rule: 'complex',
                    },
                    name: 'leads',
                    path: '/leads',
                },
                {
                    beforeEnter: (to, from, next) => {
                        if (store.getters.isAuthorized) next('/');
                        else window.location.href = LOGIN_REDIRECT_URL;
                    },
                    name: 'auth',
                    path: '/auth',
                },
                {
                    component: () => import('@/views/errors/Error404.vue'),
                    name:      'error-404',
                    path:      '/error-404',
                },
                {
                    component: () => import('@/views/errors/Error403.vue'),
                    name:      'error-403',
                    path:      '/error-403',
                },
            ],

            component: () => import('./layouts/Main.vue'),
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path:      '',
        },
        {
            component: () => import('./views/report/Index.vue'),
            meta:      {
                rule: 'complex',
            },
            name:  'report',
            path:  '/report',
            props: true,
        },
        // Redirect to 404 page, if no match found
        {
            path:     '*',
            redirect: '/error-404',
        },
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});

const excludePages = ['error-403', 'error-404', 'auth'];
const DEFAULT_RANGE_DAYS = 30;

router.beforeEach(async (to, from, next) => {
    if (!store.getters.isAuthorized) {
        try { await store.dispatch('getSession'); } catch (e) { /* no-op */ }
    }

    const { isAuthorized, userInfo, isPro } = store.getters;
    const canSeePage = to.meta.rule ? checkRole(to.meta.rule, userInfo.userRole) : true;

    if (
        !isAuthorized
        && !canSeePage
        && to.meta.rule
        && !excludePages.includes(to.name)
    ) {
        next({ name: 'auth' });
    } else if (
        isAuthorized
        && (!canSeePage || !isPro)
        && to.name !== 'error-403'
    ) {
        next({ name: 'error-403' });
    } else if (isAuthorized && to.name === 'auth') {
        next(from.path && !excludePages.includes(from.path) ? from.path : '/');
    } else {
        next();
    }

    const needStats = ['statistics', 'leads'].includes(String(to.name));
    const today = dayjs().format('YYYY-MM-DD');
    const range = [
        dayjs().subtract(DEFAULT_RANGE_DAYS, 'day').format('YYYY-MM-DD'),
        today,
    ];

    if (isAuthorized && needStats && userInfo.id) {
        const leadsStats = useLeadsStatsStore(pinia);

        await leadsStats.fetchStats({
            agentList: 0,
            ids:       userInfo.id,
            range,
        });
    }

    next();
});

export default router;
